import { ReduxProvider } from './providers/ReduxProvider';
import { QueryClientProvider } from './providers/QueryClientProvider';
import { MUIProvider } from './providers/MUIProvider';
import { I18nProvider } from './providers/I18nProvider';
import AppRouter from './router/routes';

function App() {
  return (
    <ReduxProvider>
      <QueryClientProvider>
        <I18nProvider>
          <MUIProvider>
            <AppRouter />
          </MUIProvider>
        </I18nProvider>
      </QueryClientProvider>
    </ReduxProvider>
  );
}

export default App;
